import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_SITE = {
  hero_image:
    "https://images.unsplash.com/photo-1782834294806-d0431419f024?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwcmVzdGF1cmFudCUyMGludGVyaW9yJTIwZGluaW5nfGVufDB8fHx8MTc4NzMzNTkyMHww&ixlib=rb-4.1.0&q=85",
  hero_line1: "La vie s'apprécie",
  hero_line2: "à table. J'aime la vie.",
  hero_text:
    "Cuisine portugaise pleine d'âme, servie avec l'élégance d'un bistrot. De la mer au brasero, chaque plat est une célébration.",
  hero_btn_reserve: "Réserver une table",
  hero_btn_order: "Commander",
  hero_btn_dishes: "Voir les photos",
  location_title1: "Notre terrasse",
  location_title2: "à Poigny",
  location_name: "J'aime la vie",
  location_address: "Av. des Petites Prairies, 77160 Poigny, França",
  location_hours: "Mar–Dim · 12h00–15h00 / 19h00–23h00",
  location_phone: "+33 6 66 16 82 80",
  location_map:
    "https://www.google.com/maps?q=Avenue%20des%20Petites%20Prairies%2C%2077160%20Poigny%2C%20France&output=embed",
  social_facebook: "https://www.facebook.com/profile.php?id=61593580472610",
  social_instagram: "https://www.instagram.com/jaimelavie.77/",
  social_tiktok: "#",
  footer_text: "© 2026 J'aime la vie — Restaurant",
  order_heading: "Notre cuisine, chez vous",
  order_subtext: "Commandes à emporter, par téléphone ou sur Internet.",
  order_info_title: "Horaires de retrait :",
  order_info_lines:
    "Déjeuner : 11h30 à 12h00 ou après 13h30\nDîner : 19h30 à 20h00 ou après 21h00",
  order_info_note:
    "Une question ? Une commande ? Notre équipe est à votre disposition. N'hésitez pas à nous contacter !",
  order_traiteur:
    "J'aime la Vie vous propose également un service traiteur pour tous vos événements : mariages, anniversaires, baptêmes, communions, repas d'entreprise et événements privés. Contactez-nous pour un devis personnalisé.",
  reservation_heading: "Gardez votre place à table",
  reservation_subtext: "Dites-nous quand vous venez, nous nous occupons du reste.",
  reservation_hours: "Mar–Dim · 12h00–15h00 / 19h00–23h00",
  nav_home: "Accueil",
  nav_order: "Commander",
  nav_reserve: "Réserver",
  marquee1: "Cuisine Portugaise • J'aime la vie • Expérience Unique • Saveur & Âme",
  marquee2: "Commander • Réservez votre table • J'aime la vie",
  dishes_title: "Portfolio",
  dishes_more: "Voir plus",
  dishofday_label: "Plat du jour",
  dishofday_btn: "Réserver une table",
  gallery_header: "Portfolio",
  gallery_title: "Toutes les photos",
  gallery_back: "Retour",
};

let cached = null;

export function invalidateSiteCache() {
  cached = null;
}

export const DAYS = [
  ["mon", "Lundi"],
  ["tue", "Mardi"],
  ["wed", "Mercredi"],
  ["thu", "Jeudi"],
  ["fri", "Vendredi"],
  ["sat", "Samedi"],
  ["sun", "Dimanche"],
];

export const DEFAULT_WEEKLY = {
  mon: { lunch: "", dinner: "", closed: true },
  tue: { lunch: "12h00–15h00", dinner: "19h00–23h00", closed: false },
  wed: { lunch: "12h00–15h00", dinner: "19h00–23h00", closed: false },
  thu: { lunch: "12h00–15h00", dinner: "19h00–23h00", closed: false },
  fri: { lunch: "12h00–15h00", dinner: "19h00–23h00", closed: false },
  sat: { lunch: "12h00–15h00", dinner: "19h00–23h00", closed: false },
  sun: { lunch: "12h00–15h00", dinner: "19h00–23h00", closed: false },
};

let cachedWeekly = null;

export function invalidateWeeklyCache() {
  cachedWeekly = null;
}

export function useWeeklyHours() {
  const [weekly, setWeekly] = useState(cachedWeekly || DEFAULT_WEEKLY);
  useEffect(() => {
    axios
      .get(`${API}/weekly-hours`)
      .then((r) => {
        cachedWeekly = { ...DEFAULT_WEEKLY, ...(r.data.days || {}) };
        setWeekly(cachedWeekly);
      })
      .catch(() => {});
  }, []);
  return weekly;
}

export function formatDayHours(d) {
  if (!d || d.closed) return "Fermé";
  return [d.lunch, d.dinner].filter(Boolean).join(" / ") || "Fermé";
}

const JS_DAY_KEYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];

export function weeklyDayFor(weekly, dateStr) {
  if (!dateStr) return null;
  const d = new Date(`${dateStr}T12:00:00`);
  return weekly[JS_DAY_KEYS[d.getDay()]];
}


export const WEEKDAY_SHORT = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];
export const MONTH_NAMES = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];
export const EMPTY_BLOCKED = { dates: [], weekdays: [], months: [] };

export function isBlockedDay(blocked, dateStr) {
  if (!dateStr) return false;
  const d = new Date(`${dateStr}T12:00:00`);
  return (
    blocked.dates.includes(dateStr) ||
    blocked.weekdays.includes(d.getDay()) ||
    blocked.months.includes(d.getMonth() + 1)
  );
}

export function blockedHintText(blocked) {
  return [
    ...blocked.dates.map((d) => d.split("-").reverse().slice(0, 2).join("/")),
    ...[1, 2, 3, 4, 5, 6, 0]
      .filter((w) => blocked.weekdays.includes(w))
      .map((w) => WEEKDAY_SHORT[w]),
    ...blocked.months.map((m) => MONTH_NAMES[m - 1]),
  ].join(" · ");
}

export function useSiteContent() {
  const [site, setSite] = useState(cached || DEFAULT_SITE);
  useEffect(() => {
    axios
      .get(`${API}/site-content`)
      .then((r) => {
        cached = { ...DEFAULT_SITE, ...r.data };
        setSite(cached);
      })
      .catch(() => {});
  }, []);
  return site;
}


export function getSeenIds(key) {
  try {
    return JSON.parse(localStorage.getItem(`jlv_seen_ids_${key}`) || "[]");
  } catch {
    return [];
  }
}

export function markSeenIds(key, ids) {
  const cur = new Set(getSeenIds(key));
  ids.forEach((id) => cur.add(id));
  localStorage.setItem(
    `jlv_seen_ids_${key}`,
    JSON.stringify([...cur].slice(-1000))
  );
}

export function unseenCount(items, key) {
  if (localStorage.getItem(`jlv_seen_ids_${key}`) === null) return 0;
  const seen = new Set(getSeenIds(key));
  return items.filter((i) => !seen.has(i.id)).length;
}
